/* Tatagaltier PDP behaviour — build-spec §4, §5.6.
   - Gallery: thumbnail click swaps the stage image
   - Variant radios: update ATC target + price (+ stage image if the variant has one)
   - Quantity stepper
   - Sticky mobile ATC bar: shown once the main ATC leaves the viewport (IntersectionObserver);
     clicking it submits the main product form so Dawn's AJAX cart drawer handles the add. */

class TataGallery extends HTMLElement {
  connectedCallback() {
    this.stage = this.querySelector('#TataStageImage');
    this.thumbs = [...this.querySelectorAll('[data-tata-thumb]')];
    this.thumbs.forEach((t) => t.addEventListener('click', () => this.select(t)));
  }
  select(thumb) {
    const full = thumb.getAttribute('data-full');
    if (full && this.stage) { this.stage.src = full; this.stage.srcset = ''; }
    this.thumbs.forEach((t) => t.classList.toggle('is-active', t === thumb));
  }
}
if (!customElements.get('tata-gallery')) customElements.define('tata-gallery', TataGallery);

function tataPdpInit(root) {
  const form = root.querySelector('[data-tata-pdp-form]');
  const atcId = root.querySelector('.product-variant-id');
  const priceCurrent = root.querySelector('.tata-pdp__price [data-tata-price-current]');
  const stage = root.querySelector('#TataStageImage');

  // Variant radios
  root.querySelectorAll('[data-tata-pdp-variant]').forEach((radio) => {
    radio.addEventListener('change', () => {
      if (!radio.checked) return;
      if (atcId) atcId.value = radio.value;
      const label = radio.closest('.tata-variant-btn');
      root.querySelectorAll('.tata-pdp__variants .tata-variant-btn').forEach((l) => l.classList.remove('is-selected'));
      if (label) label.classList.add('is-selected');
      const price = radio.getAttribute('data-price');
      if (price && priceCurrent) priceCurrent.textContent = price;
      const title = radio.getAttribute('data-title');
      const titleEl = root.querySelector('[data-tata-variant-title]');
      if (title && titleEl) titleEl.textContent = title;
      const media = radio.getAttribute('data-media');
      if (media && stage) { stage.src = media; stage.srcset = ''; }
    });
  });

  // Quantity stepper
  const qtyInput = root.querySelector('[data-tata-qty-input]');
  root.querySelectorAll('[data-tata-qty]').forEach((btn) => {
    btn.addEventListener('click', () => {
      if (!qtyInput) return;
      const cur = parseInt(qtyInput.value, 10) || 1;
      const next = btn.getAttribute('data-tata-qty') === 'plus' ? cur + 1 : Math.max(1, cur - 1);
      qtyInput.value = next;
      qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });

  // Sticky mobile ATC bar
  const mainAtc = root.querySelector('[data-tata-pdp-atc]');
  const sticky = root.querySelector('[data-tata-pdp-sticky]');
  const stickyAtc = root.querySelector('[data-tata-pdp-sticky-atc]');
  if (mainAtc && sticky && 'IntersectionObserver' in window) {
    const io = new IntersectionObserver(
      (entries) => {
        const e = entries[0];
        // show the bar when the main CTA is scrolled out of view
        sticky.hidden = e.isIntersecting;
      },
      { rootMargin: '0px 0px -80px 0px', threshold: 0 }
    );
    io.observe(mainAtc);
  }
  if (stickyAtc && form) {
    stickyAtc.addEventListener('click', () => {
      const submit = form.querySelector('[type="submit"]');
      if (submit) submit.click();
    });
  }
}

// Mark complementary products already in the cart as "In Cart".
function tataMarkCompInCart(card) {
  card.classList.add('is-in-cart');
  const btn = card.querySelector('[data-tata-comp-add]');
  if (btn) {
    const span = btn.querySelector('span');
    if (span) span.textContent = 'In Cart';
    btn.setAttribute('aria-disabled', 'true');
  }
}
function tataRefreshCompInCart() {
  const cards = [...document.querySelectorAll('[data-comp-product-id]')];
  if (!cards.length) return;
  fetch('/cart.js')
    .then((r) => r.json())
    .then((cart) => {
      const ids = new Set(cart.items.map((i) => String(i.product_id)));
      cards.forEach((card) => {
        if (ids.has(card.getAttribute('data-comp-product-id'))) tataMarkCompInCart(card);
      });
    })
    .catch(() => {});
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-tata-pdp]').forEach(tataPdpInit);
  tataRefreshCompInCart();
  document.querySelectorAll('[data-tata-comp-add]').forEach((btn) => {
    // re-check the cart shortly after add (Dawn's product-form posts on submit)
    btn.addEventListener('click', () => setTimeout(tataRefreshCompInCart, 900));
  });
});
